import { render, staticRenderFns } from "./ReportingHistoryTable.vue?vue&type=template&id=c6dbe8ce&scoped=true&"
import script from "./ReportingHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ReportingHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportingHistoryTable.vue?vue&type=style&index=0&id=c6dbe8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dbe8ce",
  null
  
)

/* custom blocks */
import block0 from "./ReportingHistoryTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports